// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__N1QtK","right":"Footer_right__3ZJjV","buttons":"Footer_buttons__ul8JD"};